import CrudPage from "@/components/CrudPage";
import { useAuth } from "@/context/AuthContext";

export default function Locations() {
  const { user } = useAuth();
  const canManage = ["super_admin", "head_office_admin"].includes(user?.role);
  return (
    <CrudPage
      title="Locations"
      subtitle="Manage franchise locations across the network."
      endpoint="locations"
      testid="locations"
      canManage={canManage}
      columns={[
        { key: "name", label: "Location", render: (i) => <span className="font-medium">{i.name}</span> },
        { key: "city", label: "City", render: (i) => `${i.city}, ${i.country}` },
        { key: "owner_name", label: "Franchise Owner" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "status", label: "Status", badge: true },
        { key: "created_at", label: "Created", date: true },
      ]}
      fields={[
        { name: "name", label: "Location name" },
        { name: "country", label: "Country", default: "Denmark" },
        { name: "city", label: "City" },
        { name: "address", label: "Address" },
        { name: "owner_name", label: "Franchise owner" },
        { name: "email", label: "Email" },
        { name: "phone", label: "Phone" },
        { name: "status", label: "Status", type: "select", default: "active", options: [
          { value: "active", label: "Active" }, { value: "pending", label: "Pending" }, { value: "suspended", label: "Suspended" },
        ] },
      ]}
    />
  );
}
